import gql from 'graphql-tag';

/**
 * Drives whether the home card renders. `shouldDisplay` answers "is this user
 * due?" — cadence only — so the feature flag check lives in the client
 * alongside it.
 *
 * Nothing else is asked for: the privacy copy is a static "Your employer", so
 * there is no organisation name to fetch.
 */
export const HOME_WELLBEING_MEASURE_STATUS_QUERY = gql`
  query HomeWellbeingMeasureStatus {
    wellbeingMeasureStatus {
      shouldDisplay
      lastCompletedAt
      nextAvailableAt
    }
  }
`;

/**
 * The question set, plus the working-week assumptions the Absenteeism input
 * ranges derive from.
 *
 * Fetched when the card renders rather than when it is clicked: only users who
 * are due see the card, so this costs one request for exactly the people who
 * will take the survey, and it lets the modal open straight onto question one.
 */
export const WELLBEING_MEASURE_QUESTIONNAIRE_QUERY = gql`
  query WellbeingMeasureQuestionnaire {
    wellbeingMeasureQuestionnaire {
      id
      version
      assumedWorkingHoursPerDay
      assumedWorkingDaysPerWeek
      questions {
        id
        internalName
        text
        contextText
        uiType
        scale {
          minimumValue
          maximumValue
          stepSize
          minimumLabel
          maximumLabel
        }
      }
    }
  }
`;

/**
 * Saves a completed survey. `entryPoint` is a server field, not analytics —
 * the tracking events live in ENG-21847.
 */
export const SAVE_WELLBEING_MEASURE_RESPONSES_MUTATION = gql`
  mutation SaveWellbeingMeasureResponses(
    $input: SaveWellbeingMeasureResponsesInput!
  ) {
    saveWellbeingMeasureResponses(input: $input) {
      code
      success
      submissionId
    }
  }
`;
